import { useState } from 'react';
import EarningsModal from './EarningsBody';
import styles from './index.module.scss';

const Earnings = (props: any) => {
	const { year, month, employeeId, activeTab, isUsd } = props;

	const [earningsAmount, setEarningsAmount] = useState<number>(0);
	const [earningsAmountZMW, setEarningsAmountZMW] = useState<number>(0);
	const [hasMixedCurrency, setHasMixedCurrency] = useState<boolean>(false);
	const [isFetchDataLoading, setIsFetchDataLoading] =
		useState<boolean>(false);

	return (
		<div>
			<div className={styles.earningContainer}>
				<div className={styles.headerBox}>
					<div className={styles.headerContent}>
						{/* Header Section */}
						<div className={styles.titleContainer}>
							<div className={styles.titleText}>Earnings</div>
							<div className={styles.separation}></div>
							<div className={styles.earningsCount}>
								<div className={styles.titleEarnings}>
									Total Earnings
								</div>
								<div className={styles.amountsGroup}>
									<div className={styles['earningsAmount']}>
										<span className={styles.currencyLabel}>
											{isUsd ? '$' : 'ZMW'}
										</span>
										{!isFetchDataLoading && earningsAmount != null ? earningsAmount?.toFixed(2) : ''}
									</div>
									{hasMixedCurrency && (
										<>
											<span className={styles.amountsJoiner}>+</span>
											<div className={styles['earningsAmount']}>
												<span className={styles.currencyLabel}>ZMW</span>
												{!isFetchDataLoading && earningsAmountZMW != null ? earningsAmountZMW?.toFixed(2) : ''}
											</div>
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* Earnings Modal */}
				<EarningsModal
					month={month}
					year={year}
					employeeId={employeeId}
					activeTab={activeTab}
					isUSD={isUsd}
					setEarningsAmount={setEarningsAmount}
					setEarningsAmountZMW={setEarningsAmountZMW}
					setHasMixedCurrency={setHasMixedCurrency}
					setIsLoading={setIsFetchDataLoading}
					isLoading={isFetchDataLoading}
				/>
				{/* Buttons */}
			</div>
		</div>
	);
};

export default Earnings;
